'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = require('preact-fela');

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdownButton = function dropdownButton(_ref) {
  var open = _ref.open,
      color = _ref.color,
      inside = _ref.inside;
  return {
    width: '100%',
    height: '55px',
    padding: '0 16px',
    borderWidth: '2px 0',
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderRadius: '0',
    position: 'relative',
    justifyContent: 'flex-start',
    textTransform: 'none',
    fontSize: '14px',
    transition: 'color, background-color, border-bottom-color, opacity 0.2s ease-in-out',
    willChange: 'color, background-color, border-bottom-color, opacity',
    color: open && !inside ? color : inside ? '#666' : '#ffffff',
    borderBottomColor: open && !inside ? color : null,
    opacity: !open ? '1' : null,
    ':hover': {
      opacity: !open ? '0.75' : null,
      color: open && inside ? '#999' : null
    },
    desktop: {
      height: '100%',
      alignSelf: 'stretch',
      padding: '9px 10px 10px'
    }
  };
};

exports.default = (0, _preactFela.createComponentWithProxy)(dropdownButton, _Button2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Dropdown/DropdownButton.js
// module id = 58
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38